"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var states_1 = require("../../../common/constants/states");
var InstructorCompleteSetupController = /** @class */ (function () {
    function InstructorCompleteSetupController(FlashService, UsersModel, UserService, $rootScope) {
        this.FlashService = FlashService;
        this.UsersModel = UsersModel;
        this.UserService = UserService;
        this.$rootScope = $rootScope;
        this.states = states_1.States;
        this.setupData = {};
        this.submitted = false;
        this.submitSetup = this.submitSetup.bind(this);
    }
    InstructorCompleteSetupController.prototype.submitSetup = function () {
        var _this = this;
        this.submitted = true;
        var data = {};
        if (this.setupData.address &&
            this.setupData.address.street &&
            this.setupData.address.city &&
            this.setupData.address.state &&
            this.setupData.address.zip) {
            data.address = {
                street: this.setupData.address.street,
                city: this.setupData.address.city,
                state: this.setupData.address.state,
                zip: this.setupData.address.zip,
            };
        }
        if (this.setupData.license &&
            this.setupData.license.number &&
            this.setupData.license.expiration_date) {
            data.license = {
                number: this.setupData.license.number,
                expiration_date: (0, time_1.toYMD)((0, time_1.parseMMDDYYYYDate)(this.setupData.license.expiration_date)),
            };
        }
        if (this.setupData.emergency_contact &&
            this.setupData.emergency_contact.name &&
            this.setupData.emergency_contact.phone) {
            data.emergency_contact = {
                name: this.setupData.emergency_contact.name,
                phone: this.setupData.emergency_contact.phone,
            };
        }
        this.UsersModel.completeInstructorSetup(this.instructor.id, data)
            .then(function (response) {
            _this.submitted = false;
            _this.instructor.setup_complete = true;
            if (response.message) {
                _this.FlashService.setMessage({
                    message: response.message,
                    type: "success",
                });
            }
            var user = _this.UserService.getCurrentUser();
            if (user.role.type === "instructor") {
                user.setup_complete = true;
                _this.UserService.setCurrentUser(user);
            }
            _this.$rootScope.$broadcast("INSTRUCTOR_SETUP_COMPLETE");
        })
            .catch(function (response) {
            _this.submitted = false;
        });
    };
    return InstructorCompleteSetupController;
}());
InstructorCompleteSetupController.$inject = [
    "FlashService",
    "UsersModel",
    "UserService",
    "$rootScope",
];
exports.default = InstructorCompleteSetupController;
